export default __webpack_public_path__ + "static/media/package5.9828c129.png";